(function (angular) {
	'use strict';

	angular
		.module('planModule')
		.factory('planFactory', [
			'$http',
			'$filter',
			'APP_BASE_PATH',
			'mixpanelFactory',
			planFunction
		]);

	function planFunction(
		$http,
		$filter,
		APP_BASE_PATH,
		mixpanelFactory
	) {
		
		var factory = {
			getAllocationByProperty: getAllocationByProperty,
			getDataForSelectedGoal: getDataForSelectedGoal,
			getPlanData: getPlanData,
			getPlanDemographics: getPlanDemographics,
			getAnnualizedYield: getAnnualizedYield,
			getQuarterlyReturn: getQuarterlyReturn,
			trackGoalChanged: trackGoalChanged
		};

		return factory;
		
		function getPlanData(planTypes){ 
			var queryParam = '';

			if(planTypes && planTypes.length) {
				queryParam = '?type=' + planTypes.join(',');
			}

			return $http.get(APP_BASE_PATH + '/ria/plans.json' + queryParam);
		}

		function getPlanDemographics() {
			return $http.get(APP_BASE_PATH + '/ria/plan-demographics.json');
		}
		
		function getDataForSelectedGoal(planData, selectedGoal){
			var dataForSelectedGoal;
			
			angular.forEach(planData, function(goal){
				if (goal.name === selectedGoal) {
					dataForSelectedGoal = goal;
				}
			});
			
			return dataForSelectedGoal;
		}
		
		function getAllocationByProperty(planDataByRating){
			var allocationByProperty = [];
			
			angular.forEach(planDataByRating, function(rating) {
				angular.forEach(rating.properties, function(property) {
					property.rating = {
						color: rating.color,
						letter: rating.letter,
						subletter: rating.subletter
					};

					property.rating.full = property.rating.letter + property.rating.subletter;

					allocationByProperty.push(property);
				});
			});
			
			return allocationByProperty;
		}
		
		function trackGoalChanged(selectedGoal){
			mixpanelFactory.track('Goal Selected', { 'Goal' : selectedGoal });
		}
		
		function getAnnualizedYield(planTypes, planId) {
			return	getPlanData(planTypes).then(function(response){
				var annualizedYield = $filter('filter')(response.data, { 'planId' : planId })[0].currentDividend;
				return annualizedYield;
			});
		}
		
		function getQuarterlyReturn(planTypes, planId){
			return getPlanData(planTypes).then(function(response){
				var quarterlyReturn = $filter('filter')(response.data, { 'planId' : planId })[0].projectedQuarterlyReturnMidpoint;
				return quarterlyReturn;
			});
		}
	}
})(window.angular);